module.exports = __webpack_public_path__ + "static/media/maxParties_500_1000.91f3bf61.png";